
import CadminBuilderVeAx   from 'app/actions/company-admin/builder-vol-event';
import CadminCompaniesAx   from 'app/actions/company-admin/companies';
import config              from 'app/config';
import {
  VolEventTypes,
}                          from 'app/constants';
import CadminVolEventsDuck from 'app/ducks/company-admin/vol-events';

const Types = {
  LOAD: 'CADMIN_PAGE_NEW_VOL_EVENT_LOAD',
};

const Actions = {

  load: ({params: {companySlug}, query: {type=VolEventTypes.VOL_OPP, templateId}}) => (dispatch, getState) => {
    const promise = Promise.all([
      dispatch(CadminCompaniesAx.loadCommon(companySlug)),
      dispatch(CadminBuilderVeAx.setVolEventId(null)),
      dispatch(CadminBuilderVeAx.setVolEvent({type}, [{volMinutes: 0}])),
      ...(templateId ? [
        dispatch(CadminVolEventsDuck.Ax.get(companySlug, templateId)).then(({volEvent, volEventShifts}) => {
          if (volEvent.title && volEvent.companyId !== config.systemEventsCompanyId) {
            volEvent.title = `Copy of ${volEvent.title}`;
          }
          dispatch(CadminBuilderVeAx.setVolEventId(null)), // will cause hasLoaded to change to false before changing back to true - useful for RTE
          dispatch(CadminBuilderVeAx.setVolEvent(volEvent, volEventShifts));
        })
      ] : []),
    ]);
    return dispatch({type: Types.LOAD, promise});
  },

};

export {
  Types,
};

export default Actions;
